import { atom } from 'jotai';

import { getCollectGames } from '@/api/game';
import { ACCESS_USERID_KEY } from '@/constant/config';
import Storage from '@/utils/Storage';

export const userStateAtom = atom<Record<string, any>>({
  name: 'user',
  isLogin: false,
  isLoading: true,
  is_bind_mobile: 0, //是否绑定手机
  h5cashablemoney: 0, //可提现金额
  score: 0, //当前携带
  cashnum: 0, //当日提现次数
  cashnum_share: 0, //分享提现次数
  viplevel: 0, //vip等级
  vippoint: 0, //vip点数
  showWithdrawGuide: false, //是否显示提现引导
  isFirstLogin: false, //是否首次登录
  vipurl: '',
  nextvipurl: '',
  registerDate: '',
  whatsapp_lb: { cash_can: 0, resetflag: 0, score_fetch: 0, score: 0 }
});

export const modalChaningAtom = atom<boolean>(false);

// 是否首次进入大厅
export const isFirstEntryAtom = atom<boolean>(true);

// 是否每日首次登录
export const dayFirstLoginAtom = atom<boolean>(true);

export const initDayFirstLogin = atom(null, async (get, set) => {
  const userId = Storage.getAccess(ACCESS_USERID_KEY);
  const saveTime = Storage.get('DAY_FIRST_LOGIN_TIME_' + userId, 0);
  const now = new Date();
  const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const time = Math.floor(midnight.getTime() / 1000);
  if (saveTime < time) {
    set(dayFirstLoginAtom, true);
    Storage.set('DAY_FIRST_LOGIN_TIME_' + userId, time);
  } else {
    set(dayFirstLoginAtom, false);
  }
});

// 是否显示顶部fb绑定信息
export const isShowTopFbBindAtom = atom<boolean>(false);
